export default __webpack_public_path__ + "static/media/description.1202ca13.svg";